import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Learn from "./pages/Learn";
import LessonDetail from "./pages/LessonDetail";
import Solve from "./pages/Solve";
import ProblemDetail from "./pages/ProblemDetail";
import NewProblem from "./pages/NewProblem";
import Verify from "./pages/Verify";
import SubmissionDetail from "./pages/SubmissionDetail";
import Dashboard from "./pages/Dashboard";
import Ledger from "./pages/Ledger";
import Tribunal from "./pages/Tribunal";
import Research from "./pages/Research";
import Arena from "./pages/Arena";
import Talent from "./pages/Talent";
import ShelfLanding from "./pages/ShelfLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" theme="dark" richColors />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/learn/shelf/:subject" element={<ShelfLanding />} />
            <Route path="/learn/:id" element={<LessonDetail />} />
            <Route path="/solve" element={<Solve />} />
            <Route path="/solve/new" element={<ProtectedRoute roles={["customer"]}><NewProblem /></ProtectedRoute>} />
            <Route path="/solve/:id" element={<ProblemDetail />} />
            <Route path="/verify" element={<ProtectedRoute roles={["reviewer", "adjudicator"]}><Verify /></ProtectedRoute>} />
            <Route path="/submissions/:id" element={<ProtectedRoute><SubmissionDetail /></ProtectedRoute>} />
            <Route path="/tribunal" element={<ProtectedRoute roles={["adjudicator"]}><Tribunal /></ProtectedRoute>} />
            <Route path="/research" element={<ProtectedRoute><Research /></ProtectedRoute>} />
            <Route path="/arena" element={<Arena />} />
            <Route path="/talent" element={<ProtectedRoute><Talent /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/ledger" element={<ProtectedRoute><Ledger /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
